"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../components/FalconAccordionPlugin");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var react_html_parser_1 = require("react-html-parser");
var CollapsibleQuestionWidget = /** @class */ (function (_super) {
    __extends(CollapsibleQuestionWidget, _super);
    function CollapsibleQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.checkQuestionValidations = _this.checkQuestionValidations.bind(_this);
        return _this;
    }
    CollapsibleQuestionWidget.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.setState({ isOpen: _this.checkQuestionValidations() });
        }, 400);
    };
    CollapsibleQuestionWidget.prototype.render = function () {
        var _this = this;
        var accordionTitle = this.getSetting("title");
        var bodyHtml = this.renderHtml(this.getSetting("bodyHtml") || "");
        var widgetId = this.getSetting("widgetId") !== undefined ? this.getSetting("widgetId") : "";
        if (this.props.engine.getJourneyState().idToScrollTo === widgetId) {
            setTimeout(function () {
                _this.setState({ isOpen: true });
            }, 400);
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { id: widgetId, className: this.getSetting("cssClass") !== undefined ? this.getSetting("cssClass") : "collapsible-question-panel", children: (0, jsx_runtime_1.jsxs)(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShown: this.state.isOpen, isShownClassName: "shown", toggleShown: (0, jsx_runtime_1.jsxs)("div", { id: widgetId + "Shown", className: "toggle d-flex justify-content-between align-items-center", children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold text-center fs-18", children: accordionTitle }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-icon collapse-icon" })] }), toggleHidden: (0, jsx_runtime_1.jsxs)("div", { id: widgetId + "Hidden", className: "toggle d-flex justify-content-between align-items-center", children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold text-center fs-18", children: accordionTitle }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-icon expand-icon" })] }), executeEvent: function () { return _this.executeEvent("change"); }, children: [bodyHtml, this.renderChildren()] }) }) }));
    };
    CollapsibleQuestionWidget.prototype.renderHtml = function (htmlText) {
        return (0, react_html_parser_1.default)(this.renderTemplate(htmlText, true), {
            transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            }
        });
    };
    CollapsibleQuestionWidget.prototype.renderTemplate = function (template, escapeFields) {
        return journey_services_1.ExpressionEvaluator.renderTemplate(template, this.props.interaction, escapeFields);
    };
    CollapsibleQuestionWidget.prototype.checkQuestionValidations = function () {
        var isOpen = false;
        if (this.props.validations) {
            for (var _i = 0, _a = Object.keys(this.props.validations); _i < _a.length; _i++) {
                var questionName = _a[_i];
                for (var _b = 0, _c = this.props.question.questions; _b < _c.length; _b++) {
                    var question = _c[_b];
                    if (questionName === question.name) {
                        var validationResult = this.props.validations[questionName];
                        if (validationResult.errors && validationResult.errors.length > 0) {
                            isOpen = true;
                        }
                    }
                }
            }
        }
        return isOpen;
    };
    CollapsibleQuestionWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "label", type: journey_model_1.TypeDescriptions.String },
            { name: "bodyHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], CollapsibleQuestionWidget);
    return CollapsibleQuestionWidget;
}(plugin_journey_1.GroupQuestionWidgetBase));
exports.CollapsibleQuestionWidget = CollapsibleQuestionWidget;
//# sourceMappingURL=CollapsibleQuestionWidget.js.map